import React, { useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions, IconButton, InputAdornment } from "@material-ui/core";
import { onPreventEnterSubmitting } from "../../../../utils/utils";
import { assignItem } from "../../../../services/crm/ticketService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchItem from "../../inventory/items/searchItem";
import { Search } from "@mui/icons-material";
import Swal from "sweetalert2";
import { Card } from "react-bootstrap";
import { FormTextField } from "../../../../partials/content/Forms/FormField";
const AssignItem = ({ ticketID, onReloadTicket, onCloseDialog }) => {
  const [openSearchItem, setOpenSearchItem] = useState(false);
  const [openSearchItemType, setOpenSearchItemType] = useState(false);
  const [tab, setTab] = useState({
    ID: 1,
    title: "Sellable Items",
    icon: "fas fa-boxes",
  });
  let serviceData = {
    ticketID: ticketID,
    itemID: 0,
    varCode: "",
    itemName: "",
  };

  const changeServiceFormSchema = yup.object().shape({
    itemID: yup.number(),
    varCode: yup.string(),
    itemName: yup.string().required(),
  });
  return (
    <Formik
      initialValues={serviceData}
      validationSchema={changeServiceFormSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to assign this Ticket ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, assign it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              assignItem(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Assigned",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onReloadTicket();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <FormTextField
            label="Item Name"
            name="itemName"
            searchButton
            readonly
            onSearchClick={() => {
              setOpenSearchItemType(true);
            }}
          />
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
          <DialogLayout
            open={openSearchItemType}
            title="Select Item Type"
            onCloseDialog={() => {
              setOpenSearchItemType(false);
            }}
            maxWIdth="md"
          >
            <div className="row menu-row-modules mt-4">
              <div className="col-sm-3 col-md-3 col-lg-3">
                <div className="menu-grid-square">
                  <Card
                    className="card-select-type"
                    onClick={() => {
                      setOpenSearchItemType(false);
                      setOpenSearchItem(true);
                      setTab({
                        ID: 1,
                        title: "Sellable Items",
                        icon: "fas fa-boxes",
                      });
                    }}
                  >
                    <Card.Body>
                      <div className="menu-title mb-2">Sellable Items</div>
                      <i className="fas fa-boxes fa-4x"></i>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="col-sm-3 col-md-3 col-lg-3">
                <div className="menu-grid-square">
                  <Card
                    className="card-select-type"
                    onClick={() => {
                      setOpenSearchItemType(false);
                      setOpenSearchItem(true);
                      setTab({
                        ID: 2,
                        title: "Services",
                        icon: "fas fa-tools",
                      });
                    }}
                  >
                    <Card.Body>
                      <div className="menu-title mb-2">Services</div>
                      <i className="fas fa-tools fa-4x"></i>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="col-sm-3 col-md-3 col-lg-3">
                <div className="menu-grid-square">
                  <Card
                    className="card-select-type"
                    onClick={() => {
                      setOpenSearchItemType(false);
                      setOpenSearchItem(true);
                      setTab({
                        ID: 3,
                        title: "Item Packages",
                        icon: "fab fa-dropbox",
                      });
                    }}
                  >
                    <Card.Body>
                      <div className="menu-title mb-2">Item Packages</div>
                      <i className="fab fa-dropbox fa-4x"></i>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="col-sm-3 col-md-3 col-lg-3">
                <div className="menu-grid-square">
                  <Card
                    className="card-select-type"
                    onClick={() => {
                      setOpenSearchItemType(false);
                      setOpenSearchItem(true);
                      setTab({
                        ID: 4,
                        title: "Assets",
                        icon: "fas fa-building",
                      });
                    }}
                  >
                    <Card.Body>
                      <div className="menu-title mb-2">Assets</div>
                      <i className="fas fa-building fa-4x"></i>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </div>
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchItemType(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchItem}
            title="Search Item"
            onCloseDialog={() => {
              setOpenSearchItem(false);
              setOpenSearchItemType(true);
            }}
            minHeight={true}
          >
            <SearchItem
              tab={tab}
              selectSellableItems={true}
              selectServiceItems={true}
              selectAssetItems={true}
              selectItemPackages={true}
              selectVariant={true}
              onSelectItem={(item, varCode, valueName) => {
                setFieldValue("itemID", item.ID);
                setFieldValue("varCode", varCode);
                setFieldValue("itemName", item.itemName + " " + valueName);
                handleCloseSearchItem();
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchItem(false);
                  setOpenSearchItemType(true);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
        </form>
      )}
    </Formik>
  );

  function handleCloseSearchItem() {
    setOpenSearchItem(false);
  }
};

export default AssignItem;
